<form [formGroup]="form" (ngSubmit)="onSubmit()">
  <h2 mat-dialog-title>Add Vessel</h2>

  <mat-dialog-content>
    <p>Add a new vessel to the registry.</p>

    <mat-form-field appearance="outline">
      <mat-label>Name</mat-label>
      <input type="text" matInput formControlName="name" />
    </mat-form-field>
  </mat-dialog-content>

  <mat-dialog-actions>
    <button mat-flat-button type="submit" [disabled]="!form.valid">Add</button>
    <button mat-button type="button" (click)="onCancel()">Cancel</button>
  </mat-dialog-actions>
</form>
